/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Filtergrayscale1Inputs */

const en_filtergrayscale1 = /** @type {(inputs: Filtergrayscale1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Black & white`)
};

const de_filtergrayscale1 = /** @type {(inputs: Filtergrayscale1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schwarz-weiß`)
};

/**
* | output |
* | --- |
* | "Black & white" |
*
* @param {Filtergrayscale1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const filtergrayscale1 = /** @type {((inputs?: Filtergrayscale1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Filtergrayscale1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_filtergrayscale1(inputs)
	return de_filtergrayscale1(inputs)
});
export { filtergrayscale1 as "filterGrayscale" }